import React from 'react'
import injectSheet from 'react-jss'
import styles from './prev-next-controls.styles'
import classNames from 'classnames'
import BackIcon from '../icons/back-icon'
import ForwardIcon from '../icons/forward-icon'

const PrevNextControls = ({
  classes,
  position,
  onPrevSlide,
  onNextSlide,
  className
}) => (
  <div className={classNames(classes.container, className)}>
    <BackIcon
      className={classNames(classes.icon, 'metrics__prev-next-controls')}
      onClick={onPrevSlide}
    />
    {position}
    <ForwardIcon
      className={classNames(classes.icon, 'metrics__prev-next-controls')}
      onClick={onNextSlide}
    />
  </div>
)

export default injectSheet(styles)(PrevNextControls)
